import cogoToast from 'cogo-toast';
import { SUCCESS } from 'constants/notificationStatus';

export default ({ message, status = SUCCESS }) =>
  cogoToast[status](message, {
    position: 'top-right',
    bar: { size: '6px' },
    hideAfter: 5,
  });
